import gql from 'graphql-tag';

export const deleteCREREntry = gql`
  mutation deleteCREREntry($id: String) {
    deleteCREREntry(id: $id) {
      value
    }
  }
`;
